/* istanbul ignore file */
import { SERVICE_CATALOG_STATUSES } from 'domain/shared/serviceCatalog';
import CreateServiceCatalogButton from 'domain/organization/serviceCatalog/shared/button/CreateServiceCatalogButton';
import ServiceCatalogLink from 'domain/organization/serviceCatalog/shared/field/ServiceCatalogLink';
import { DateField, BadgeField } from 'framework/ui/field';
import { EmployeeLinkFieldWithNameLoading, EmployeeFilter } from 'domain/shared/employee';
import ServiceCatalogStatusBadge from '../shared/field/ServiceCatalogStatusBadge';
import ServiceCatalogHealthBadge from 'domain/organization/serviceCatalog/shared/field/ServiceCatalogHealthBadge';
import { Filters, QuickFilter, FiltersLayout, ListHeader, DataGridLayout, ListPageLayout } from 'framework/list';

const ServiceCatalogListPageContent = () => {
  const filters = (
    <Filters>
      <FiltersLayout
        quickFilters={[
          <QuickFilter
            label="All not archived services"
            state={{ status: { ne: SERVICE_CATALOG_STATUSES.ARCHIVED } }}
          />,
        ]}
      >
        <EmployeeFilter label="Owner" source="owner" />
      </FiltersLayout>
    </Filters>
  );

  return (
    <ListPageLayout
      header={<ListHeader label="Service Catalog" />}
      actions={[<CreateServiceCatalogButton />]}
      filter={filters}
    >
      <DataGridLayout>
        {[
          <BadgeField
            badges={[
              <ServiceCatalogStatusBadge source="status" />,
              <ServiceCatalogHealthBadge source="currentHealth.issues" />,
            ]}
            label="Name"
            width="40%"
          >
            <ServiceCatalogLink source="id" nameSource="name" label="Name" width="40%" />
          </BadgeField>,
          <EmployeeLinkFieldWithNameLoading source="owner" label="Owner" />,
          <DateField source="updatedAt" label="Last modified date" width="20%" isSortable />,
        ]}
      </DataGridLayout>
    </ListPageLayout>
  );
};

export default ServiceCatalogListPageContent;
